<template>
<div>
    <div @click="clicked" :color="button_color" nw-data="logInOut" class="nw_logInOut">
        <div  style="display:inline-block;margin:8px;">
        <template v-if="$store.getters.busy==0">
            <v-icon v-if="message===null" v-text="'fa-user-md'"/>
            <div v-else v-html="message"></div>
        </template>
        <v-progress-circular v-else indeterminate size="20"></v-progress-circular>
        </div>
        <span :class="$style.messages" v-text="$store.getters.user ? labels('button > sign_out') : labels('button > sign_in')"/>
    </div> 
</div>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: 'transparent'
        },
        button_message: {
            type: String,
            default: null
        }
    },
    data: function(){
        return {
            buttonLock: false,
            timer: null,
            waitMessage: null
        }
    },
    methods: {
        clicked: function(){
            var self = this;
            if(self.buttonLock===false){
                if(self.$store.getters.user){
                    self.$controller.security.user.logout();
                }else{
                    self.$controller.view.login.open(null, 'SignInButton::AppBar');
                }
            }else{
                self.waitMessage = 'Please wait';
            }
        },
        lock: function(){
            var self = this;

            self.buttonLock=true;
            clearTimeout(self.timer);
            self.timer = setTimeout(function(){
                self.buttonLock = false;
                self.waitMessage = null;
            },1000);
        }
    },
    computed:{
        button_color: function(){
            return this.waitMessage ? 'orange' : this.color;
        },
        message: function(){
            return this.waitMessage ? this.waitMessage : this.button_message;
        },
        busy: function(){
            return this.$store.getters.busy>0;
        }
    },
    watch: {
        busy: function(){
            if(this.busy===true){
                this.lock();
            }
        }
    }
}
</script>

<style module>

@media only screen and (max-width: 933px){
.messages{
    display:none;
}
}
</style>